module.exports = __webpack_public_path__ + "static/media/Luciene.170078f7.jpg";